import styled from '@emotion/styled';

export const Wrapper = styled.div`
  min-height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${(props) => props.theme.color.medium.default};
`;

export const IconWrapper = styled.div`
  font-size: 56px;
  color: ${(props) => props.theme.color.light.shade};
  margin-bottom: 20px;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const BackWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 5px;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  cursor: pointer;

  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;
